import { Rma } from '../../api/api-generated';
import { stringIncludesIgnoreCaseIgnoreNullSubstring } from '../../utils/comparisons';
import { RmaItemFilter, RmaItemForm } from './RmaTypes';

export const filterRmas = (
  item: Rma,
  filters: RmaItemFilter | undefined
): boolean => {
  if (!filters) return true;
  if (
    filters.hardwareType &&
    Number(item.hardware.hardwareTypeId) !== Number(filters.hardwareType.id)
  )
    return false;
  if (
    filters.nameId &&
    !stringIncludesIgnoreCaseIgnoreNullSubstring(item.nameId, filters.nameId)
  )
    return false;
  if (
    filters.company &&
    !stringIncludesIgnoreCaseIgnoreNullSubstring(
      item.company.companyName,
      filters.company.companyName
    )
  )
    return false;
  if (
    filters.serial &&
    !stringIncludesIgnoreCaseIgnoreNullSubstring(
      item.hardware.serial,
      filters.serial
    )
  )
    return false;
  return true;
};

export const filterConstraintChecker = (
  name: string,
  value: string,
  filters: RmaItemFilter
) => {
  return true;
};

export const emailSignature = `LPT Support Team
LP Technologies, Inc
Tel: 316-831-9696 ext 103 | Fax: 316-831-9692`;

export const buildInitialEmail = (
  rmaId: string,
  contactName: string,
  analyzerType: string,
  serial: string,
  issue: string,
  notes: string
): string => {
  return `${contactName},

Thank you for your business. We appreciate it!

Please use RMA # ${rmaId} to send your ${analyzerType} SN# ${serial} back for evaluation and repair.

The shipping address is:

LP Technologies, Inc
Attn: Service Dept/RMA
7330 W 13th St N
Wichita, KS 67212

${issue && `Issue: ${issue}`}
${notes && `Notes: ${notes}`}

Please feel free to contact us directly if you have any questions.


Best regards,

${emailSignature}
`;
};

export const buildCompletedEmail = (
  analyzerType: string,
  serial: string,
  contactName: string
): string => {
  return `${contactName},

Thank you for your business. We appreciate it!

We received the ${analyzerType} SN ${serial} that you sent back for evaluation and repair. Our service department reported that the _________________ will need to be replaced. The unit is no longer under warranty, so the total repair cost for parts, labor and testing comes to $_______ + shipping and handling.  Once we receive your PO for the repair cost, our techs will repair the unit and send it to the shipping department.

If you need it faster, please provide us with your FedEx, UPS, or DHL account number, and we will ship it per instructions.

Once any repairs are completed, we will notify you. If we remain in possession of your unit(s) three months after such notification, the unit(s) will incur a storage fee of $90 per month. Six months after such notification, the unit(s) will be considered abandoned and surrendered to us. 

Feel free to contact us directly by phone or email if you have any questions.

Best regards,

${emailSignature}
`;
};

export const itemValidator = (item: RmaItemForm) => {
  if (!item.nameId) return false;
  if (!item.creationDate) return false;
  if (!item.hardware) return false;
  if (!item.company) return false;
  if (!item.contactName) return false;
  if (!item.email) return false;
  if (item.status === 'Closed' && !item.shipDate) return false;
  return true;
};
